import React from 'react';
import { Link } from 'react-router-dom';
import LogInForm from './components/LogInForm';
import {withTranslation} from "react-i18next";

const LogIn = ({t}) => (
  <div className="account">
    <div className="account__wrapper">
      <div className="account__card">
        <div className="account__head">
          <h3 className="account__title">{t('login.welcome_to')}
            <span className="account__logo"> {t('login.platform_name')}
              <span className="account__logo-accent"></span>
            </span>
          </h3>
          <h4 className="account__subhead subhead">{t('login.platform_descriptiom')}</h4>
        </div>
        <LogInForm onSubmit />
        {false
          ? (<><div className="account__or">
            <p>Don't have Steem account?</p>
          </div>
            <div className="account__social">
              <Link className="btn btn-outline-primary account__btn account__btn--small" to="/login">Create Steem Account</Link>
            </div></>)
          : null
        }
      </div>
    </div>
  </div>
);

export default withTranslation('dashboard')(LogIn);

// if you want to add select, date-picker and time-picker in your app you need to uncomment the first
// four lines in /scss/components/form.scss to add styles
